import { createContext } from "react";
import type { IEnvironment } from "../types/EnvironmentTypes";

export type TargetAPI = "registry" | "environment";

export type AppContextType = {
  title: string;
  setTitle: (newValue: string) => void;
  targetAPI: TargetAPI;
  setTargetAPI: (newValue: TargetAPI) => void;
  selectedEnvironment: IEnvironment | undefined;
  setSelectedEnvironment: (newValue: IEnvironment | undefined) => void;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);
